export const PERSONALIZED_MEAL_SECTION = 'personalized_meal_section';
export const TWO_STAGE_ORDERING = 'two_stage_ordering';
export const TEMPO_TAGGED_REVIEWS = 'tempo_tagged_reviews';
export const TEMPO_PICK_MEALS2 = 'tempo_pick_meals2';
export const TEMPO_IDME_OFFER = 'tempo_idme_offer';
export const PLANS_STANDARD_FUNNEL = 'plans_standard_funnel3';
export const HUB_REDIRECT = 'hub_redirect';
